import React, { useState } from "react";
import { FormInputButton } from "./Button";
import Loading from "./Loading";
import { FadeUp, FadeInAndShrink } from "./AnimationLibrary"

const EnterCode = props => {
	const [code, setCode] = useState("");
	
	const handleSetCode = (newCode) => {
		setCode(newCode.replace(/[^0-9]/g, '').substring(0,6));
	};

	const handleVerifyLocally = async e => {
		e.preventDefault();
		props.handleVerify(code, props.optionUsed);
	}

	const handleSendNewCodeLocally = async e => {
		e.preventDefault();
		props.handleSendNewCode(props.optionUsed);
	};

	const readyToVerify = /^[0-9]{6}$/.test(code); // 6 digits

	const codeSentMessage = ['help', 'entercode'].includes(props.optionUsed.type) ? ''
		: <FadeInAndShrink delay="0">
				<p>{`${props.sentCodeCounter > 1 ? 'Another' :'A'} verification code has been sent to you at ${props.optionUsed.value}.`}</p>
			</FadeInAndShrink>
	
	const maybeSendNewCode = (props.optionUsed.type === 'entercode' ? ''
		: <a href="/" onClick={handleSendNewCodeLocally} className="arrow-link no-icon">Send a new code</a>);
	
	const loadingText = () => {
		if (props.verifyingCode) return "Verifying code...";
		if (props.sendingCode) return `Sending ${props.sentCodeCounter > 0 ? "new" : ""} code...`;
		return '';
	};

	return (
		<>
			{props.codeSendSuccess ? codeSentMessage : ""}
			{loadingText() ? <Loading loadingMessage={loadingText()}/>: ''}
			<FadeUp delay="0">
				<h3 className="sub-heading">Enter the code you received:</h3>
			</FadeUp>
			<form onSubmit={handleVerifyLocally}>
				<FadeUp delay="150">
					<input
						// Reference: https://www.twilio.com/blog/html-attributes-two-factor-authentication-autocomplete?utm_source=Iterable&utm_medium=email&utm_campaign=the_overflow_newsletter&utm_content=02-19-20
						className="code-field"
						type="text"
						name="enter-code"
						aria-label="Enter the code you received"
						onChange={e => handleSetCode(e.target.value)}
						inputMode="numeric" // from Reference
						autoComplete="one-time-code" // from Reference - Allows browser to get one-time-code from messages
						pattern="[0-9]*"
						maxLength="6"
						value={code}
						autoFocus
						required
						disabled={props.verifyingCode}
						data-testid="enter-code-field"
					/>
				</FadeUp>
				<FadeUp delay="250">
					<FormInputButton
						label={!props.verifyingCode ? "Verify code" : "Verifying code..."}
						inputClassNames="btn"
						disabled={!readyToVerify || props.verifyingCode}
						onClick={handleVerifyLocally}
						dataTestId="verify-code"
					/>
				</FadeUp>
			</form>
			{maybeSendNewCode}
		</>
	);
};

export default EnterCode;
